export default "__VITE_ASSET__BEFnLufR__"